import { render, staticRenderFns } from "./viewPrize.vue?vue&type=template&id=c0c4fc12&scoped=true&"
import script from "./viewPrize.vue?vue&type=script&lang=js&"
export * from "./viewPrize.vue?vue&type=script&lang=js&"
import style0 from "./viewPrize.vue?vue&type=style&index=0&id=c0c4fc12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c4fc12",
  null
  
)

export default component.exports